import React from 'react';
import { trackEvent } from '../firebaseAnalytics';

// Keep the Studio CTA ready for launch; switch this one value when direct onboarding reopens.
export const LAUNCH_MODE = 'live';

export default function LaunchCta({ className, source, style, onClick, withArrow = false }) {
  const handleClick = (event) => {
    onClick?.(event);
  };

  if (LAUNCH_MODE === 'waitlist') {
    return (
      <a
        className={className}
        data-waitlist-open={source}
        href="#openWaitlist"
        onClick={handleClick}
        style={style}
      >
        Join waitlist {withArrow ? <span aria-hidden="true">→</span> : null}
      </a>
    );
  }

  return (
    <a
      className={className}
      href="https://studio.promptera.io"
      onClick={(event) => {
        trackEvent('app_open', { source });
        handleClick(event);
      }}
      style={style}
    >
      Start for Free {withArrow ? <span aria-hidden="true">→</span> : null}
    </a>
  );
}

